(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("UI"), require("SolidLogic"), require("rdflib"));
	else if(typeof define === 'function' && define.amd)
		define(["UI", "SolidLogic", "rdflib"], factory);
	else if(typeof exports === 'object')
		exports["SolidPanes"] = factory(require("UI"), require("SolidLogic"), require("rdflib"));
	else
		root["SolidPanes"] = factory(root["UI"], root["SolidLogic"], root["rdflib"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__9426__, __WEBPACK_EXTERNAL_MODULE__5663__, __WEBPACK_EXTERNAL_MODULE__5491__) => {
return 